import React, { ReactNode } from 'react';
import classnames from 'classnames';
import { InfinitePagination } from '@funtech-int/rival';

import { ScrollSentinel } from '../ScrollSentinel/ScrollSentinel';

import styles from './_Layout.module.css';

export interface RenderItemProps<T> {
    item: T;
    prevItem: T | null;
    index: number;
    className: string;
}

interface LayoutProps<T> {
    items: T[];
    renderItem: (props: RenderItemProps<T>) => ReactNode;
    pagination?: InfinitePagination;
    className?: string;
}

export function Layout<T>({ items, renderItem, pagination, className }: LayoutProps<T>) {
    return (
        <div className={classnames(styles.root, className)}>
            {items.map((item, index) =>
                renderItem({
                    item,
                    prevItem: items[index - 1] || null,
                    index,
                    className: styles.item,
                })
            )}
            {pagination ? <ScrollSentinel pagination={pagination} direction="end" /> : null}
        </div>
    );
}
